import {
    store
} from '@store/store';
export const _url = url => url;
// export const _url = url => url + (url.indexOf('?') === -1?'?':'&') + 'cuid=' + (store.getters.user? store.getters.user.id: 0);
